(function () {
    var model = angular.module('metadataSearchModule', []);

    model.controller(controllers.metadataController, ['$scope', '$state', '$http', '$document', 'folderService', '$uibModalInstance', 'quickSearchKeyword', 'metaDataService', 'broadcastService', 'configService',
        function ($scope, $state, $http, $document, folderService, $modalInstance, quickSearchKeyword, metaDataService, broadcastService, configService) {
        $scope.translation = globalResources;
        $scope.currentData = {
            advanceSearchKeyword: quickSearchKeyword,
            folderName: '',
            selectedFolderId: 0,
        };
        $scope.selectedItem = {
            selectedMetadata: null,
            selectedTag: null
        };
        
        $scope.initMetadata = {
            metadatas: [],
            tags: []
        };
        

        $scope.folderTree = [];
        $scope.filterOptionNeededMessage = globalResources.FilterOptionNeededMessage;
        $scope.showTreeDocument = false;
        $scope.key_showRemoveIcon = false;
        $scope.folder_showRemoveIcon = false;

        $scope.initMetadataSearchData = initMetadataSearchData;
        $scope.onMetadataSearch = onMetadataSearch;
        $scope.close = close;
        $scope.loadFolderTree = loadFolderTree;
        $scope.hidePopupOnLostFocus = hidePopupOnLostFocus;
        $scope.selectNodeHead = selectNodeHead;
        $scope.selectNodeLabel = selectNodeLabel;
        $scope.hideTooltip = hideTooltip;
        $scope.clear_advKeyword = clear_advKeyword;
        $scope.clear_advFolder = clear_advFolder;
        $scope.showDocumentInTree = configService.getBool(HandbookConfiguration.ShowDocumentsInTree);

        function initMetadataSearchData() {
            setTimeout(function () {
                $('#adv_keyword').focus();
            }, 1000);

            //Init chapter base on url
            var id = $state.params.folderId;
            if (id != undefined && id > 0 && $state.current.name == 'folder') {
                folderService.getFolderById(id).then(function (response) {
                    $scope.currentData.folderName = response.data.name;
                    $scope.currentData.selectedFolderId = response.data.id;
                });;
            }
            $scope.key_showRemoveIcon = ($scope.currentData.advanceSearchKeyword != undefined && $scope.currentData.advanceSearchKeyword.length > 0);

            getRegisterItems();
        };

        function getRegisterItems() {
            metaDataService.getRegisterAndRegisterItems().then(function (data) {
                if (data) {
                    $scope.initMetadata.metadatas = data;
                }
            });
        };

        $scope.$watch('selectedItem.selectedMetadata', function (selectedMetadata) {
            $scope.selectedItem.selectedTag = null;
            if (selectedMetadata != null && selectedMetadata != undefined) {
                getMetadataTags(selectedMetadata.registerItemId);
            } 
        });

        function getMetadataTags(registerItemId) {
            metaDataService.getMetadataTags(registerItemId).then(function (data) {
                if (data) {
                    $scope.initMetadata.tags = data;
                }
            });
        };

        function onMetadataSearch() {
            if ($scope.currentData.selectedFolderId != 0 || $scope.selectedItem.selectedRegister != null || $scope.currentData.advanceSearchKeyword != '') {
                $scope.filterOptionNeededMessage = '';
                $state.go(handbookActions.SearchResultAction, {
                    keyword: $scope.currentData.advanceSearchKeyword,
                    searchInContents: 1,
                    folderId: $scope.currentData.selectedFolderId,
                    registerItemId: $scope.selectedItem.selectedMetadata != null ? $scope.selectedItem.selectedMetadata.registerItemId : null,
                    registerItemValueId: $scope.selectedItem.selectedTag != null ? $scope.selectedItem.selectedTag.registerItemValueId : null,
                    type: 4
                });
                $modalInstance.close(true);
                broadcastService(broadcastType.resetQuickSearchKeyword, null);
            }
            else {
                $scope.filterOptionNeededMessage = globalResources.FilterOptionNeededMessage;
            }
        };

        $document.bind('click', function (event) {
            var isClickedElementChildOfPopup = $('.folder-search')
              .find(event.target)
              .length > 0;

            if (isClickedElementChildOfPopup)
                return;
            $scope.showTreeDocument = false;
        });

        function close() {
            $modalInstance.close(true);
        }

        function loadFolderTree() {
            $scope.showTreeDocument = !$scope.showTreeDocument;
            if ($scope.showTreeDocument) {
                if ($scope.folderTree.length == undefined || $scope.folderTree.length == 0) {
                    $http.get(handbookRequests.GetFoldersRequest, { params: { 'Id': null, 'showDocumentInTree': $scope.showDocumentInTree } })
                         .success(function (data, status, headers, config) {
                             $scope.folderTree = data;
                         });
                }
            }
        };

        function hidePopupOnLostFocus() {
            $scope.showTreeDocument = false;
        };

        function selectNodeHead(node) {
            if (!node.isLoaded) {
                $http.get(handbookRequests.GetSubfoldersRequest, { params: { 'folderId': node.id } })
                    .success(function (data, status, headers, config) {
                        node.children = data;
                        node.isLoaded = true;
                    })
                    .error(function (data, status, headers, config) {
                        node.isLoaded = true;
                    });
            }
        };

        function selectNodeLabel(node) {
            $scope.currentData.folderName = node.name;
            $scope.currentData.selectedFolderId = node.id;
            $scope.folder_showRemoveIcon = ($scope.currentData.selectedFolderId != undefined && $scope.currentData.selectedFolderId > 0);
            folderService.setFolder(node);
            hidePopupOnLostFocus();
            hideTooltip();
        };

        function hideTooltip() {
            if (angular.element('#btnAdvanceSearch').scope().tt_isOpen) {
                angular.element('#btnAdvanceSearch').scope().tt_isOpen = false;
            }
            $scope.key_showRemoveIcon = ($scope.currentData.advanceSearchKeyword != undefined && $scope.currentData.advanceSearchKeyword.length > 0);
        };

        function clear_advKeyword() {
            $scope.currentData.advanceSearchKeyword = '';
            $scope.key_showRemoveIcon = false;
        };

        function clear_advFolder() {
            $scope.currentData.folderName = '';
            $scope.currentData.selectedFolderId = 0;
            $scope.folder_showRemoveIcon = false;
        };
        
    }]);

})();